import { useContext } from 'react';

import SelectStoreAndDateContext from './SelectStoreAndDateContext';

const useSelectStoreAndDateContext = () => {
  return useContext(SelectStoreAndDateContext);
};

export default useSelectStoreAndDateContext;
